import axios from "axios";
import { BASE_URL } from "../misc/Static_routes";
import { toast } from "react-toastify";
import { store } from "../app/store";
import { login, logOut } from "../app/features/usersSlice";
axios.defaults.withCredentials = true;

const notify = (message) => toast.error(`${message}`, {});
const notifySuccess = (message) => toast.success(`${message}`, {});

export const signIn = (data) => {
  const result = axios
    .post(`${BASE_URL}/api/admin/signIn`, data)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        const usrData = response?.data?.user;
        store.dispatch(login(usrData));
        return response.data;
      }
    })
    .catch((err) => {
      notify(err?.response?.data?.message);
    });
  return result;
};

export const signOut = async () => {
  const result = axios
    .post(`${BASE_URL}/api/admin/logOut`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        store.dispatch(logOut());
        notifySuccess(response?.data?.message);
      }
    })
    .catch((err) => {
      notify(err?.response?.data?.message);
    });
  return result;
};

export const fethcAllUsers = () => {
  const result = axios
    .get(`${BASE_URL}/api/admin/users`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    })
    .catch((err) => {
      notify(err?.response?.data?.message);
    });

  return result;
};

export const createUser = async (data) => {
  const result = axios
    .post(`${BASE_URL}/api/admin/users`, { data })
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        notifySuccess(response?.data?.message);
        return response.data;
      }
    })
    .catch((err) => {
      notify(err?.response?.data?.message);
    });

  return result;
};

export const deleteUser = async (data) => {
  const result = axios
    .delete(`${BASE_URL}/api/admin/users/delete/${data.id}`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        notifySuccess(response?.data?.message);
        return response.data;
      }
    })
    .catch((err) => {
      notify(err?.response?.data?.message);
    });

  return result;
};

export const updateUser = async (data) => {
  const result = axios
    .patch(`${BASE_URL}/api/admin/users`, data)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        notifySuccess(response?.data?.message);
        return response.data;
      }
    })
    .catch((err) => {
      notify(err?.response?.data?.message);
    });

  return result;
};
